export default __webpack_public_path__ + "static/IBMPlexSans-MediumItalic-Latin2-e98222f1655d7addfa95ea844e99f555.woff";